import {
  book_sports_facility,
  events,
  events_white,
  e_shop,
  private_function,
  restaurant_reservation,
} from '../../assets/base64';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { NavigationService } from '../../services/navigation';

export const DASHBOARD_MENU = [
  {
    title: 'BOOK SPORTS \n& RECREATION',
    icon: IS_WEB
      ? addBase64Prefix(book_sports_facility)
      : require('../../assets/book-sports-facility.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'Sports',
          params: {
            screen: 'Facility',
          },
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'BOOK EVENTS\n',
    icon: IS_WEB
      ? addBase64Prefix(events_white)
      : require('../../assets/events.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'EventList',
          params: {
            screen: 'Grid',
          },
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'RESTAURANT RESERVATION',
    icon: IS_WEB
      ? addBase64Prefix(restaurant_reservation)
      : require('../../assets/restaurant-reservation.png'),
    onPress: () => {
      NavigationService.push('GrillRoom');
    },
    requiredLogin: true,
  },
  {
    title: 'ORDER FROM \nKCC E-SHOP',
    icon: IS_WEB ? addBase64Prefix(e_shop) : require('../../assets/e-shop.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'EShopHomePage',
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'DINING MENUS\n',
    icon: require('../../assets/dining-menus.png'),
    onPress: () => {
      NavigationService.push('DinningMenu');
    },
    requiredLogin: true,
  },
  {
    title: 'BOOK A PRIVATE FUNCTION',
    icon: IS_WEB
      ? addBase64Prefix(private_function)
      : require('../../assets/private-function.png'),
    onPress: () => {
      NavigationService.push('PrivateFunction');
    },
    requiredLogin: true,
  },
  {
    title: 'DINING \nPROMOTIONS',
    icon: require('../../assets/dining-promotions.png'),
    onPress: () => {
      NavigationService.push('DinningPromotion');
    },
    requiredLogin: false,
  },
  {
    title: 'BOOK SPORTS \nCOACHING',
    icon: require('../../assets/book-sports-coaching.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'Sports',
          params: {
            screen: 'Coaching',
          },
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'NEWS \n',
    icon: require('../../assets/news.png'),
    onPress: () => {
      NavigationService.push('ClubNews');
    },
    requiredLogin: true,
  },
  {
    title: 'NOTICES \n',
    icon: require('../../assets/notices.png'),
    onPress: () => {
      NavigationService.push<'Notices'>('Notices', {
        screen: 'new',
      });
    },
  },
  {
    title: 'MY ACCOUNT\n',
    icon: require('../../assets/my-account.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyAccountTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MY BOOKINGS\n',
    icon: require('../../assets/my-bookings.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyBookingsTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'MY PROFILE\n',
    icon: require('../../assets/my-profile.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MyAccountTab',
      });
    },
    requiredLogin: true,
  },
  {
    title: 'SERVICES & FORMS\n',
    icon: require('../../assets/services-forms.png'),
    onPress: () => {
      NavigationService.push('ServiceForm');
    },
    requiredLogin: true,
  },
  {
    title: 'SURVEY\n',
    icon: require('../../assets/survey.png'),
    onPress: () => {
      NavigationService.push('Survey');
    },
    requiredLogin: true,
  },
];

export const DASHBOARD_DESTOP_MENU = [
  {
    title: 'BOOK SPORTS &\nRECREATION',
    icon: IS_WEB
      ? addBase64Prefix(book_sports_facility)
      : require('../../assets/book-sports-facility.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'Sports',
          params: {
            screen: 'Facility',
          },
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'BOOK EVENTS',
    icon: IS_WEB
      ? addBase64Prefix(events_white)
      : require('../../assets/events.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'EventList',
          params: {
            screen: 'Grid',
          },
        },
      });
    },
    requiredLogin: true,
  },
  {
    title: 'RESTAURANT\nRESERVATION',
    icon: IS_WEB
      ? addBase64Prefix(restaurant_reservation)
      : require('../../assets/restaurant-reservation.png'),
    onPress: () => {
      NavigationService.push('GrillRoom');
    },
    requiredLogin: true,
  },
  {
    title: 'BOOK A PRIVATE\nFUNCTION',
    icon: IS_WEB
      ? addBase64Prefix(private_function)
      : require('../../assets/private-function.png'),
    onPress: () => {
      NavigationService.push('PrivateFunction');
    },
    requiredLogin: true,
  },
  {
    title: 'ORDER FROM \nKCC E-SHOP',
    icon: IS_WEB ? addBase64Prefix(e_shop) : require('../../assets/e-shop.png'),
    onPress: () => {
      NavigationService.push<'Root'>('Root', {
        screen: 'MenuTab',
        params: {
          screen: 'EShopHomePage',
        },
      });
    },
    requiredLogin: true,
  },
];
